import { useEffect, useState } from "react";
import { DownloadCloud, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { precacheScorm, markScormOffline, getScormOffline, useOfflineStatus } from "../../lib/offline/offlineApi";

/** Bouton « Disponible hors ligne » pour un module SCORM (met en cache tous les fichiers du package). */
export function ScormOfflineButton({ api, contentId }) {
  const { online } = useOfflineStatus();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { getScormOffline(contentId).then(setInfo).catch(() => {}); }, [contentId]);

  const download = async () => {
    setBusy(true);
    try {
      const n = await precacheScorm(api, contentId);
      await markScormOffline(contentId, n);
      setInfo({ at: Date.now(), files: n });
      toast.success(`Module disponible hors ligne (${n} fichiers)`);
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  if (info && !busy) {
    return (
      <button onClick={download} disabled={!online} className="inline-flex items-center gap-1 text-[11px] font-bold text-emerald-400 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 disabled:opacity-60" title="Cliquer pour mettre à jour" data-testid="scorm-offline-ready">
        <CheckCircle2 className="w-3.5 h-3.5" /> Disponible hors ligne
      </button>
    );
  }
  return (
    <button onClick={download} disabled={busy || !online} className="inline-flex items-center gap-1 text-[11px] font-bold text-sky-300 px-2.5 py-1 rounded-full bg-sky-500/10 border border-sky-500/20 disabled:opacity-60" data-testid="scorm-offline-btn">
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <DownloadCloud className="w-3.5 h-3.5" />} {busy ? "Téléchargement…" : "Disponible hors ligne"}
    </button>
  );
}

export default ScormOfflineButton;
